var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress__top__loading",class:[ _vm.canSuccess ? 'success' : 'fail' ],style:({ opacity: _vm.show ? 1 : 0, width: _vm.percent + '%' })})
}
var staticRenderFns = []

export { render, staticRenderFns }